import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import ClienteForm from './pages/ClienteForm';
import ClienteDetail from './pages/ClienteDetail';
import Contratos from './pages/Contratos';
import ContratoForm from './pages/ContratoForm';
import ContratoDetail from './pages/ContratoDetail';
import Pagos from './pages/Pagos';
import PagoForm from './pages/PagoForm';
import PagoDetail from './pages/PagoDetail';
import FlujoCaja from './pages/FlujoCaja';
import PagosReales from './pages/PagosReales';
import PagoRealForm from './pages/PagoRealForm';
import Propuestas from './pages/Propuestas';
import PropuestaForm from './pages/PropuestaForm';
import PropuestaDetail from './pages/PropuestaDetail';
import Conceptos from './pages/Conceptos';
import ConceptoForm from './pages/ConceptoForm';
import Reportes from './pages/Reportes';
import RubrosPresupuestales from './pages/RubrosPresupuestales';
import RubroPresupuestalForm from './pages/RubroPresupuestalForm';
import Presupuesto from './pages/Presupuesto';
import Gastos from './pages/Gastos';
import GastoForm from './pages/GastoForm';
import DashboardFinanciero from './pages/DashboardFinanciero';
import AnalisisPresupuestal from './pages/AnalisisPresupuestal';
import RentabilidadConceptos from './pages/RentabilidadConceptos';

import { ToastProvider } from './context/ToastContext';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              
              {/* Clientes */}
              <Route path="clientes" element={<Clientes />} />
              <Route path="clientes/nuevo" element={<ClienteForm />} />
              <Route path="clientes/:id" element={<ClienteDetail />} />
              <Route path="clientes/:id/editar" element={<ClienteForm />} />
              
              {/* Contratos */}
              <Route path="contratos" element={<Contratos />} />
              <Route path="contratos/nuevo" element={<ContratoForm />} />
              <Route path="contratos/:id" element={<ContratoDetail />} />
              <Route path="contratos/:id/editar" element={<ContratoForm />} />
              
              {/* Pagos */}
              <Route path="pagos" element={<Pagos />} />
              <Route path="pagos/nuevo" element={<PagoForm />} />
              <Route path="pagos/:id" element={<PagoDetail />} />
              <Route path="pagos/:id/editar" element={<PagoForm />} />
              <Route path="flujo-caja" element={<FlujoCaja />} />
              <Route path="pagos-reales" element={<PagosReales />} />
              <Route path="pagos-reales/:id/editar" element={<PagoRealForm />} />
              
              {/* Propuestas */}
              <Route path="propuestas" element={<Propuestas />} />
              <Route path="propuestas/nueva" element={<PropuestaForm />} />
              <Route path="propuestas/:id" element={<PropuestaDetail />} />
              <Route path="propuestas/:id/editar" element={<PropuestaForm />} />
              
              {/* Conceptos */}
              <Route path="conceptos" element={<Conceptos />} />
              <Route path="conceptos/nuevo" element={<ConceptoForm />} />
              <Route path="conceptos/:id/editar" element={<ConceptoForm />} />
              
              {/* Rubros Presupuestales */}
              <Route path="rubros-presupuestales" element={<RubrosPresupuestales />} />
              <Route path="rubros-presupuestales/nuevo" element={<RubroPresupuestalForm />} />
              <Route path="rubros-presupuestales/:id/editar" element={<RubroPresupuestalForm />} />
              
              {/* Presupuesto */}
              <Route path="presupuesto" element={<Presupuesto />} />
              
              {/* Gastos */}
              <Route path="gastos" element={<Gastos />} />
              <Route path="gastos/nuevo" element={<GastoForm />} />
              <Route path="gastos/:id/editar" element={<GastoForm />} />
              
              {/* Dashboard Financiero */}
              <Route path="dashboard-financiero" element={<DashboardFinanciero />} />
              
              {/* Análisis Presupuestal */}
              <Route path="analisis-presupuestal" element={<AnalisisPresupuestal />} />
              
              {/* Rentabilidad */}
              <Route path="rentabilidad-conceptos" element={<RentabilidadConceptos />} />
              
              {/* Reportes */}
              <Route path="reportes" element={<Reportes />} />
            </Route>
          </Routes>
        </Router>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
